import React, { useRef } from "react";
import useHover from "../hooks/useHover";
import Checkmark from "../misc/elements/Checkmark";

const FillInComplete = ({ type, onClick, action }) => {
  const hover = useHover();
  const checkmarkRef = useRef();
  return (
    <div
      style={{ display: "flex", width: "50%" }}
      onClick={() => checkmarkRef.current.click()}
    >
      <div style={{ flex: 1 }} />
      <div
        className="divRow"
        {...hover.divProps}
        style={{
          cursor: "pointer",
          width: "50%",
          justifyContent: "space-between",
          backgroundColor: hover.hover ? "#6f6f6f" : "#cccccc",
          padding: "10px",
          borderRadius: ".5rem/.5rem",
          marginTop: "20px",
          marginBottom: "20px",
        }}
      >
        <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <div
            className="textWhite"
            style={{ color: hover.hover ? "white" : "#6f6f6f" }}
          >
            All Set
          </div>
        </div>
        <div
          className="textBoldWhite"
          style={{
            marginRight: "5px",
            color: hover.hover ? "white" : "#4f4f4f",
          }}
        >{`${action} ${type}`}</div>
        <Checkmark
          checkmarkRef={checkmarkRef}
          size="50px"
          divWidth={"50px"}
          blackWhite={!hover.hover}
          onChecked={onClick}
        />
      </div>
    </div>
  );
};

export default FillInComplete;
